export enum StorageKey {
  TOKEN_ID = "fsm_tkn"
}
